module.exports = __webpack_public_path__ + "img/business_white.53bb9940.png";